import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // {
  //   path: '/newindex',
  //   name:'NewIndex',
  //   component:() => import('../pages/Index/index.vue')
  // },
  {
    path: '/index',
    name: 'Index',
    component: () => import('../pages/Index/index.vue')
  },
  {
    path: '/part2',
    name: 'Part2',
    component: () => import('../pages/Part2.vue')
  },
  {
    path: '/manufacture',
    name: "Manufacture",
    component: () => import('../pages/TechnicalStrength/index.vue')
  },
  {
    path: '/license',
    name: "license",
    component: () => import('../pages/license.vue')
  },
  {
    path: '/contactus',
    name: 'Contactus',
    component: () => import('../pages/BusinessCooperation/index.vue')
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: () => import('../pages/Homepage.vue')
  },
  {
    path: '/newsInformation',
    name: 'NewsInformation',
    component: () => import('../pages/News/index.vue')
  },
  {
    path: '/productDisplay',
    name: 'ProductDisplay',
    component: () => import('../pages/Product/index.vue')
  },
  {
    path: '/details/:id',
    name: 'details',
    component: () => import('../pages/News/detail.vue')
    
  },
  {
    path: '/customer-case',
    name: 'customerCase',
    component: () => import('../pages/CustomerCase/index.vue')

  },
  {
    path: '/customer-case/:id',
    name: 'customerCaseDetails',
    component: () => import('../pages/CustomerCase/details.vue')

  },
  // 重定向
  {
    path: "",
    component: () => import('../pages/Index/index.vue')
    // component: () => import('../pages/index.vue')
  },
  {
    path: '/404',
    component: () => import('@/pages/ErrorPage/404.vue'),
    meta: {
      hide: true
    }
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('@/pages/ErrorPage/404.vue'),
    meta: {
      hide: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.afterEach((to, from, next) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
})

export default router
